"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    name: "LargeCheckInput",
    props: {
        value: {
            type: Boolean,
            default: ""
        },
        attr: {
            type: Boolean
        }
    },
};
